import React, { Component } from "react";
import axios from "axios";
export default {
  httpPost(url, postdata) {
    return axios.post(url, postdata);
  },
  httptokenpost(url, postdata) {
    const token = localStorage.getItem("doctorAdminToken");
    const parsedToken = token ? JSON.parse(token) : {};
    const options = {
      headers: {
        Authorization: parsedToken.accessToken || "",
      },
    };
    return axios.post(url, postdata, options);
  },
  httptokenget(url) {
    const token = localStorage.getItem("doctorAdminToken");
    const parsedToken = token ? JSON.parse(token) : {};
    const options = {
      headers: {
        Authorization: parsedToken.accessToken || "",
      },
    };
    return axios.get(url, options);
  },
  httptokendelete(url) {
    const token = localStorage.getItem("doctorAdminToken");
    const parsedToken = token ? JSON.parse(token) : {};
    const options = {
      headers: {
        Authorization: parsedToken.accessToken || "",
      },
    };
    return axios.delete(url, options);
  },
  httptokenput(url, putdata) {
    const token = localStorage.getItem("doctorAdminToken");
    const parsedToken = token ? JSON.parse(token) : {};
    const options = {
      headers: {
        Authorization: parsedToken.accessToken || "",
      },
    };
    return axios.put(url, putdata, options);
  },
};
